var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ roulette: true, blink: _vm.fixed }},[_vm._v(" "+_vm._s(_vm.displayNum)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }